// extracted by mini-css-extract-plugin
export var actionText = "_kg-4";
export var container = "_kg-0";
export var leftSection = "_kg-1";
export var rightSection = "_kg-2";
export var settingsButton = "_kg-6";
export var settingsIcon = "_kg-7";
export var shortcut = "_kg-5";
export var shortcutGroup = "_kg-3";